import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=dc95a074&scoped=true&"
import script from "./Form.vue?vue&type=script&setup=true&lang=js&"
export * from "./Form.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Form.vue?vue&type=style&index=0&id=dc95a074&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc95a074",
  null
  
)

export default component.exports